class HTMLContent extends HTMLElement {
  connectedCallback() {
    // NEW: prefer child <script type="application/json">, else fall back to `html` attribute
    var ta = document.createElement("textarea");
    var val;
    var jsonNode = this.querySelector('script[type="application/json"]');

    if (jsonNode) {
      var raw = jsonNode.textContent || '""';
      try {
        val = JSON.parse(raw);
      } catch (e) {
        val = raw;
      }
      jsonNode.remove(); // don't leave payload in DOM
    } else {
      var attr = this.getAttribute("html") || '""';
      this.removeAttribute("html"); // scrub asap
      // Decode attribute entities (&quot;, &amp;, \u003c) then parse JSON
      ta.innerHTML = attr;
      var decoded = ta.value;
      try {
        val = JSON.parse(decoded);
      } catch (e) {
        val = decoded;
      }
    }

    // Array (list-of-values) → join as lines; else to string
    var s = Array.isArray(val) ? val.join("\n") : String(val || "");

    // If content still has entities (&lt; etc.), decode once
    if (/&[a-z#0-9]+;/i.test(s)) {
      ta.innerHTML = s;
      s = ta.value;
    }

    // Normalize CRLF/CR → LF
    s = s.replace(/\r\n?/g, "\n");

    // If HTML tags are present, render as HTML; else map newlines to <br>
    if (/<[^>]+>/.test(s)) {
      this.innerHTML = s;
    } else {
      this.innerHTML = s.replace(/\n/g, "<br>");
    }
  }
}

if (!customElements.get("html-content")) {
  customElements.define("html-content", HTMLContent);
}
